
import { Vue, Options } from "vue-class-component";
import { ErrorMessage } from "vee-validate";
import { Prop } from "vue-property-decorator";

@Options({
  components: { ErrorMessage }
})
export default class FieldError extends Vue {
  @Prop({ type: String, required: true }) name = "";
}
